import React from 'react';
import { Button } from 'reactstrap';
import { TableAction } from './types';

interface BulkActionsProps<T> {
  selectedCount: number;
  actions: TableAction<T>[];
  onClear: () => void;
}

const BulkActions = <T extends Record<string, any>>({
  selectedCount,
  actions,
  onClear,
}: BulkActionsProps<T>) => {
  if (selectedCount === 0) return null;

  return (
    <div 
      className="position-fixed bottom-0 start-50 translate-middle-x mb-4 z-3"
      style={{ width: 'max-content', minWidth: '350px' }}
    >
      <div className="bg-dark text-white rounded-pill px-4 py-3 shadow-lg d-flex align-items-center justify-content-between gap-4">
        <div className="d-flex align-items-center">
          <span className="badge bg-primary rounded-circle me-3 d-flex align-items-center justify-content-center fw-bold" style={{ width: 28, height: 28, fontSize: '0.9rem' }}>
            {selectedCount}
          </span>
          <div className="d-flex flex-column">
            <span className="fw-medium text-nowrap">
              {selectedCount} alerte{selectedCount > 1 ? 's' : ''} sélectionnée{selectedCount > 1 ? 's' : ''}
            </span>
          </div>
        </div>
        
        <div className="vr mx-2" style={{ height: '30px', opacity: 0.3 }}></div>
        
        <div className="d-flex gap-2 align-items-center">
          {actions.map((action, idx) => {
            return (
              <Button 
                key={idx}
                color={action.variant || 'primary'} 
                size="sm" 
                className="rounded-pill px-3 fw-medium"
                onClick={() => action.onClick({} as T, -1)} // Pass dummy data since it's a bulk action
              >
                {action.icon && <i className={`${action.icon} me-1`}></i>}
                {action.label}
              </Button>
            );
          })}
          
          <Button 
            color="link" 
            size="sm" 
            className="text-white text-decoration-none p-0 px-2 fw-normal opacity-75 hover-opacity-100"
            onClick={onClear}
          >
            Effacer
          </Button>
        </div>
      </div>
    </div>
  );
};

export default BulkActions;
